import React from 'react';
import {ChipField, ReferenceField, TabbedShowLayout, TextField} from 'react-admin';
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import {propertyRowStyle} from "../../tools_property_row_style";
import {d4UrlSchema} from "../../Env";
import {renderDateField, renderIfExists, renderProperties, renderReferenceField} from '../../d4tools_tab';

function D4OrgTabOrganisation(props, controllerProps) {
    const {record} = controllerProps;

    // Check if the component should be rendered
    const shouldRender = record &&
        record['@context'] &&
        JSON.stringify(Object.values(record['@context'])).includes(`${d4UrlSchema}/organisation.jsonld`);

    if (!shouldRender) return null;

    return (
        <TabbedShowLayout.Tab label="Organisation" icon={<AccountTreeIcon/>}>
            <TextField label="Name" source="organisation:objName"/>
            {renderIfExists(record, "organisation:description",
                <TextField label="Description" source="organisation:description"/>
            )}
            {renderReferenceField(record, "organisation:hasPart", "organisations", "Has Part", props)}
            {renderIfExists(record, "organisation:isPartOf",
                <ReferenceField label="Is Part Of" source="organisation:isPartOf" reference="organisations">
                    <ChipField source="objName" clickable/>
                </ReferenceField>
            )}
            {renderReferenceField(record, "organisation:roleClientOf", "organisations", "Client Of", props)}
            {renderReferenceField(record, "organisation:roleDeliversTo", "organisations", "Delivers To", props)}
            {renderReferenceField(record, "organisation:functionalResponsibility", "functions", "Functional Responsibility", props)}
            {renderReferenceField(record, "organisation:productResponsibility", "products", "Product Responsibility", props)}
            {renderProperties(record, "organisation:properties", propertyRowStyle)}
            {renderDateField(record, "organisation:created", "Created")}
            {renderDateField(record, "organisation:modified", "Modified")}
            {renderDateField(record, "organisation:expired", "Expired")}
        </TabbedShowLayout.Tab>
    );
}

export default D4OrgTabOrganisation;
